<template>
  <path
    d="M17 6.00018C13.69 6.00018 11 8.69018 11 12.0002C11 15.3102 13.69 18.0002 17 18.0002C20.31 18.0002 23 15.3102 23 12.0002C23 8.69018 20.31 6.00018 17 6.00018ZM5 8.00018C2.79 8.00018 1 9.79018 1 12.0002C1 14.2102 2.79 16.0002 5 16.0002C7.21 16.0002 9 14.2102 9 12.0002C9 9.79018 7.21 8.00018 5 8.00018ZM5 14.0002C3.9 14.0002 3 13.1002 3 12.0002C3 10.9002 3.9 10.0002 5 10.0002C6.1 10.0002 7 10.9002 7 12.0002C7 13.1002 6.1 14.0002 5 14.0002Z"
  />
</template>
